<template>
  <div class="animated fadeIn">
    <!-- <div class="splash" v-if="!preloadDone">
      <div class="container d-flex h-100">
        <div
          class="row justify-content-center text-primary w-100 align-self-center text-white"
        >
          <i class="fa fa-spin fa-spinner"></i>
        </div>
      </div>
    </div> -->
    <div class="container mt-3">
      <div class="table-caption">NIF's Excluídos</div>
      <template>
        <div>
          <b-card>
            <Grid name="NifsExcluidosGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' v-bind:pagesize="pagesize" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
          </b-card>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Grid from '@/components/Grid.vue'

export default {
  name: 'NifsExcluidosGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      pagesize: 30,
      url: 'stars/nifsexcluded',
      columns: [{
        field: 'category',
        title: 'Categoria',
        values: [{
          value: 'campanhas pontos',
          text: 'campanhas pontos'
        }, {
          value: 'statistics',
          text: 'statistics'
        }, {
          value: 'scorecard',
          text: 'scorecard'
        }, {
          value: 'incentivos internos',
          text: 'incentivos internos'
        }]
      },
      {
        field: 'operator_name',
        title: 'Operador',
        width: '220px'
      },
      {
        field: 'dealer_name',
        title: 'Distribuidor',
        width: '120px'
      },
      {
        field: 'nif',
        title: 'NIF'
      },
      {
        field: 'codle',
        title: 'CODLE',
        width: '160px'
      },
      {
        field: 'date_start',
        title: 'Excluído desde'
      },
      {
        field: 'date_end',
        title: 'Excluído até'
      }
      ]
    }
  } /* 
  methods: {},
  created() {
    var that = this
    var user = this.$auth.user()
    this.axios.get('stars/nifsexcluded').then((response) => {
      that.results = response.data.data
      that.preloadDone = true
    })
  } */
}
</script>



// WEBPACK FOOTER //
// nifsexcluidos.vue?22736a95